import * as React from 'react';

import {BulletedList} from 'shells/bulleted-list/bulleted-list';
import {OnboardingBody} from 'shells/onboarding-page/onboarding-body';

import type {ExternalServiceType} from 'nutshell-graphql-types';

import {getServiceNoun} from '../../helpers';

type Props = {
    serviceType: ExternalServiceType;
};

export function Introduction(props: Props) {
    const serviceNoun = getServiceNoun(props.serviceType);

    return (
        <OnboardingBody title={`Experience the convenience of ${serviceNoun} meetings in Nutshell`}>
            <div className='mt-16'>
                <BulletedList
                    bullets={[
                        `Gain valuable insights with AI-generated summaries for all your recorded ${serviceNoun} meetings`,
                        'Seamlessly track meeting history with automatic timeline entries',
                        'Access recordings and read meeting transcriptions, all within Nutshell',
                    ]}
                />
            </div>
        </OnboardingBody>
    );
}
